import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { App } from "./App";
import { oidcConfig } from "./lib/config";
import "./styles.css";

/** Strip the OIDC query params after sign-in so a refresh does not replay the
 *  authorization code, which Cognito rejects the second time. */
function onSigninCallback(): void {
  window.history.replaceState({}, document.title, window.location.pathname);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
